//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Disponibilidade() { 
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }



  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Disponibilidade
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação do critério:
            </h4>
            <br></br>
            <p align="justify"> <strong> Critério que identifica o grau em que os documentos gerados decorrentes do processo de desenvolvimento estão disponíveis para consulta 
              dos stakeholders do projeto. Além disso, verifica o versionamento dos documentos de forma a garantir o acesso ao histórico dos artefatos. </strong> </p>
              <p align="justify"> <strong> Qual é o seu peso na avaliação desse critério? Digite no campo abaixo </strong> </p>
            <Form.Control
                    placeholder=""
                    style={{  }}
                    value={answers['inicial'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'inicial')
                    }}
                    required
                    
                  />
            <br></br>

            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Avaliação dos critérios:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Repositório padrão: A equipe de desenvolvimento deve manter um repositório com todos os documentos gerados pelo processo de implementação do software 
              de forma que estejam organizados e que permitam que consultas de documentos sejam eficientes. Como essa boa prática é atendida? <Attention />
              </Form.Label>
              <div>
                 <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao1"
                                checked={answers[1] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao1"
                                checked={answers[1] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao1"
                                checked={answers[1] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao1"
                                checked={answers[1] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Controle de acesso: O repositório padrão deve apresentar um controle de acesso, de modo que todos os stakeholders possam acessar a documentação por meio de acesso 
              individual e que todos os acessos e modificações sejam salvos em log. Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao2"
                                checked={answers[2] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao2"
                                checked={answers[2] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao2"
                                checked={answers[2] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao2"
                                checked={answers[2] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 4;
                                  setAnswers(answers_)
                                }}
                              />

                
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Rastreamento de mudanças: Todos os documentos devem apresentar um histórico de versões, registrando-se as principais mudanças de uma versão para outra. Assim, 
              facilitará para o leitor identificar as mudanças realizadas na documentação. Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao3"
                                checked={answers[3] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao3"
                                checked={answers[3] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao3"
                                checked={answers[3] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao3"
                                checked={answers[3] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>
            
            <br></br>

            <button onClick={(e) => {

            }} className="btn btn-success btn-lg w-100">
              Gerar resultado
            </button>
            <ModalMensagem/>














          </div>
        </div>
      </div>

    </div>
  );
}
